import React from 'react';
import styles from './marketCard.module.css';
import ChevronIconBig from '../icons/chevronIconBig';

const MarketCard = ({
  market,
  lastElementRef,
  index,
  onRestaurantClick,
  logoUrl,
  domainTarget,
}) => {
  return (
    <div
      ref={lastElementRef}
      key={index}
      className={`${styles.restaurantCard} mt-2`}
      onClick={() => onRestaurantClick(market.marketSetupId)}
      style={{
        display:
          (domainTarget === 'APP' && !market.canRegisterConcierges) ||
          (domainTarget === 'APPCUSTOMER' && !market.canRegisterCustomers)
            ? 'none'
            : '',
      }}
    >
      <div className='col-auto p-0 ml-3'>
        <span className={styles.containerImg}>
          <img className={styles.imgRestaurant} src={logoUrl} alt='logo-restaurant' />
        </span>
      </div>
      <div className='col p-0 ml-3'>
        <div className='bold font-normal text-white'>{market.countryName}</div>
        <div className='text-secondary font-small'>{market.cityName}</div>
      </div>
      <div className='col-auto pl-0'>
        <ChevronIconBig fillColor={'var(--color-primary)'} size={47} />
      </div>
    </div>
  );
};

export default MarketCard;
